/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Font_SizeInputs */

const en_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR Font Size`)
};

const fr_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taille de police ADR`)
};

const de_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Schriftgröße`)
};

const it_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensione carattere ADR`)
};

const ru_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Размер шрифта ADR`)
};

const es_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamaño de fuente ADR`)
};

const zh_cn2_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR字体大小`)
};

const ja_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRフォントサイズ`)
};

const hi_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर फ़ॉन्ट आकार`)
};

const pt_pt2_options_adr_font_size = /** @type {(inputs: Options_Adr_Font_SizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamanho da fonte ADR`)
};

/**
* | output |
* | --- |
* | "ADR Font Size" |
*
* @param {Options_Adr_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_font_size = /** @type {((inputs?: Options_Adr_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_font_size(inputs)
	if (locale === "de") return de_options_adr_font_size(inputs)
	if (locale === "it") return it_options_adr_font_size(inputs)
	if (locale === "ru") return ru_options_adr_font_size(inputs)
	if (locale === "es") return es_options_adr_font_size(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_font_size(inputs)
	if (locale === "ja") return ja_options_adr_font_size(inputs)
	if (locale === "hi") return hi_options_adr_font_size(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_font_size(inputs)
	return en_options_adr_font_size(inputs)
});